export default "__VITE_ASSET__9bd2f87e__"